export const DATA_EXTRACTION_SET_MODALS = 'DATA_EXTRACTION_SET_MODALS';
export const DATA_EXTRACTION_CLOSE_ALL_MODALS = 'DATA_EXTRACTION_CLOSE_ALL_MODALS';
export const INITIAL_VALUES_LOG_SESSION_FORM = 'INITIAL_VALUES_LOG_SESSION_FORM';
export const DATA_EXTRACTION_SET_MODAL_PROCESS_DATA = 'DATA_EXTRACTION_SET_MODAL_PROCESS_DATA';

/**
 * Sets an modal active.
 * @param modalType
 * @param modalValue // isOpen
 * @param ressourceId
 * @returns {{type: string, modalType: bool,  isOpen: bool, ressourceId: int}}
 */
export const setModal = (modalType, modalValue, resourceId = false) => {
  return {
    type: DATA_EXTRACTION_SET_MODALS,
    modalType,
    isOpen: modalValue,
    resourceId
  };
};

/**
 * Closes all modals, reverts to closed state.
 * @returns {{type: string}}
 */
export const closeAllModals = () => {
  return {
    type: DATA_EXTRACTION_CLOSE_ALL_MODALS
  };
};

/**
 * set initial Values for logSessionForm
 * @returns {{type: string}}
 */
export const setIntialValuesLogSessionForm = values => {
  return {
    type: INITIAL_VALUES_LOG_SESSION_FORM,
    values
  };
};

/**
 * Opens a start session modal
 * @param sessionId
 */
export const openStartSessionModal = sessionId => {
  return dispatch => {
    dispatch(setModal('startSession', true, sessionId));
  };
};

/**
 * Opens a quality session modal
 * @param sessionId
 */
export const openQualitySessionModal = sessionId => {
  return dispatch => {
    dispatch(setModal('qualitySession', true, sessionId));
  };
};
/**
 * Opens a log session modal
 * @param sessionId
 */
export const openLogSessionModal = sessionId => {
  return dispatch => {
    dispatch(setModal('logSession', true, sessionId));
  };
};

/**
 * Opens a messages session modal
 * @param sessionId
 */
export const openMessagesSessionModal = dataTreeId => {
  return dispatch => {
    dispatch(setModal('messagesSession', true, dataTreeId));
  };
};

/**
 * Opens a worker form modal
 * @param sessionId
 */
export const openWorkerFormModal = () => {
  return dispatch => {
    dispatch(setModal('workerForm', true));
  };
};

/**
 * @param sessionId
 * Opens a messages session modal
 */
export const openDownloadModal = resource => {
  return dispatch => {
    dispatch(setModal('downloadModal', true, resource));
  };
};

/**
 * Open confirm processData modal
 * @returns {dataFileId,metricName, dataQty}
 */
export const openProcessDataConfirmData = (fileDataId, metricName, dataQty) => {
  return {
    type: DATA_EXTRACTION_SET_MODAL_PROCESS_DATA,
    isOpen: true,
    fileDataId,
    metricName,
    dataQty
  };
};



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/data/fileImport/modalActions.js